<template>
  <div class="user-item__tasks">
    <Loader v-if="!activeNorm" :isSmall="true" bg-color="#fff"></Loader>
    <table v-else class="d-table d-table__norm d-table__tasks marg-10-bottom">
      <thead>
      <tr>
        <th class="d-table__title" colspan="2"><h4>Årsverk</h4></th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="activeNorm.length < 1">
        <td class="italic">Ikke tildelt årsverk</td>
      </tr>
      <tr v-for="item in activeNormFormatted" v-if="activeNorm.length > 0">
        <td>{{ item.title }}</td>
        <td>{{ item.value }}</td>
      </tr>
      </tbody>
    </table>
    <table class="d-table d-table__norm d-table__tasks marg-10-bottom">
      <tbody>
      <tr>
        <td><b>Sum planfestet arbeidstid</b></td>
        <td class="is-number"><b>{{ planfestet }}</b></td>
      </tr>
      <tr>
        <td>Undervisning</td>
        <td class="is-number">{{ user.v_user_subjects_hours_label }}</td>
      </tr>
      <tr>
        <td>Oppgaver</td>
        <td class="is-number">{{ user.v_user_tasks_hours_label }}</td>
      </tr>
      <tr>
        <td><b>Sum egendisponibel resttid</b></td>
        <td class="is-number"><b>{{ egenDisponibel }}</b></td>
      </tr>
      </tbody>
    </table>
    <table class="d-table d-table__tasks marg-10-bottom">
      <thead>
      <tr>
        <th class="d-table__title" colspan="2">
          <div class="d-table__title__header">
            <h4>Undervisning</h4>
          </div>
        </th>
        <th class="is-number">
          {{ user.v_total_teaching_percentage_label }}
        </th>
        <th class="is-number">
          {{ user.v_user_subjects_hours_label }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="user.v_user_subjects.length < 1">
        <td class="italic">Ingen undervisning</td>
      </tr>
      <tr v-for="task in user.v_user_subjects" :key="task.id">
        <td>
          <div class="task-with-edit">
            <div class="subjects_subject subjects_subject__simple"
                 v-if="task.can_schedule || !task.hasOwnProperty('can_schedule')"
                 :style="[{'border-left-color': task.color}, {'background-color': task.color}]">
              {{ task.name }}
            </div>
            <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
          </div>
        </td>
        <td class="is-number">
          {{ task.v_calendar }}
        </td>
        <td class="is-number">
          {{ task.v_percentage_label }}
        </td>
        <td class="is-number">
          {{ task.v_hours_label }}
        </td>
      </tr>
      </tbody>
    </table>
    <table class="d-table d-table__tasks marg-10-bottom">
      <thead>
      <tr>
        <th class="d-table__title"><h4>Oppgaver</h4></th>
        <th class="is-number">{{ user.v_user_tasks_hours_label }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="user.v_user_tasks.length < 1">
        <td>Ingen oppgaver</td>
      </tr>
      <tr v-for="task in user.v_user_tasks" :key="task.id">
        <td>
          <div class="task-with-edit">
            <div class="subjects_subject subjects_subject__simple"
                 v-if="task.can_schedule || !task.hasOwnProperty('can_schedule')"
                 :style="[{'border-left-color': task.color}, {'background-color': task.color}]">
              {{ task.name }}
            </div>
            <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
          </div>
        </td>
        <td class="is-number">
          {{ task.v_hours_label }}
        </td>
      </tr>
      </tbody>
    </table>
    <SubjectsDistributionUserAgreements :userId="user.id" :userAgreements="activeUserAgreements"
                                        :isReadAgreements="false"></SubjectsDistributionUserAgreements>
  </div>
</template>
<script>
import SubjectsDistributionUserAgreements from '../SubjectsDistribution/SubjectsDistributionUserAgreements.vue'
import Loader from '../common/Loader.vue'

export default {
  props: {
    user: {
      type: Object,
      default: null
    },
    activeNorm: {
      default: null
    },
    activeNormFormatted: {
      type: Array,
      default: null
    }
  },
  components: {Loader, SubjectsDistributionUserAgreements},
  computed: {
    planfestet () {
      const teaching = this.user.v_user_subjects_hours ? this.user.v_user_subjects_hours * 1 : 0
      const tasks = this.user.v_user_tasks_hours ? (this.user.v_user_tasks_hours * 1) : 0
      return (teaching + tasks).toFixed(2)
    },
    egenDisponibel () {
      const teaching = this.user.v_user_subjects_hours ? this.user.v_user_subjects_hours * 1 : 0
      const tasks = this.user.v_user_tasks_hours ? (this.user.v_user_tasks_hours * 1) : 0
      const totalHours = this.user.v_assigned_total_hours ? (this.user.v_assigned_total_hours * 1) : 0
      return (totalHours - tasks - teaching).toFixed(2)
    }
  }
}
</script>

<style scoped>
.user-item__tasks {
  padding-top: 0.5rem;
  margin-top: 0.5rem;
  border-top: 1px solid #eee;
}

@import "../../assets/css/variables.css";

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table__tasks {
  border-collapse: collapse;
  background-color: #ffffff;
  width: 100%;
}

.d-table__tasks thead th:first-child,
.d-table__tasks tbody td:first-child {
  max-width: 220px;
  width: calc(100% - 50px);
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th,
.d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 4px 8px;
}

.d-table > tfoot tr td {
  color: #8898aa;
}

.d-table > tfoot tr td.th-sorter--active {
  color: var(--dark-blue);
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 8px;
}

.d-table tbody tr:hover {
  background: #eee !important;
}

.subjects_subject {
  width: 100%;
  max-width: 165px;
  min-width: 125px;
  position: relative;
  padding: 4px 6px;
  height: 30px;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 5px 5px 5px 0px;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
}

.subjects_subject {
  border: 1px solid #d8d8d8;
  border-left: 2px solid transparent;
  background: #fff !important;
  color: #3e4450;
  box-shadow: none;
}

.subjects_subject.subjects_subject--not-subject {
  box-shadow: none;
  background: transparent !important;
  color: var(--dark-blue) !important;
  border: 1px solid transparent;
}

.subjects_subject.subjects_subject--not-subject:hover {
  /* border: 1px solid var(--border-color); */
  border: none;
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.italic {
  font-style: italic;
}

.d-table__norm tr:hover {
  cursor: default;
}

.d-table__norm tr > td:nth-child(2) {
  text-align: right;
}

.d-table__title__header {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// ArbeidsplanUser.vue?1e01227c